import { LAYOUTS } from "../_Layouts.js";

export const APP_SWITCH_APPEARANCE = Object.freeze({
  THEME: { AESTHETIC: LAYOUTS.IS_MODE_DARK === true ? 1 : 0 },
  LAYOUT: {
    STRUCTURE: LAYOUTS.LAYOUT_PUBLIC?.APPEARANCE_GLOBAL?.LAYOUT_LEVEL ?? 1,
    FONT_APP: LAYOUTS.LAYOUT_PUBLIC?.APPEARANCE_GLOBAL?.FONTS_LEVEL ?? 1,
  },
  STYLES: {
    HEADER_TOP_PUBLIC: LAYOUTS.LAYOUT_PUBLIC?.HEADER?.APPEARANCE_LOCAL ?? 1,
    HEADER_TOP_PRIVATE: LAYOUTS.LAYOUT_PRIVATE?.HEADER?.APPEARANCE_LOCAL ?? 1,
    DASHBOARD_TABLES: 1, ALERT: 1, ALERT_POSITION: 1, CONFIRM_ALERT: 1, RICH_EDITOR: 1,
  },
});
